// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Void from "../Data.Void/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var Leibniz = function (x) {
    return x;
};
var unDistinguished = function () {
    return Unsafe_Coerce.unsafeCoerce;
};
var unDistinguished1 = /* #__PURE__ */ unDistinguished();
var trans = function (v) {
    return function (v1) {
        return function ($32) {
            return v1(v($32));
        };
    };
};
var symm = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var semigroupoidLeibniz = {
    compose: /* #__PURE__ */ Data_Function.flip(trans)
};
var runLeibniz = function (v) {
    return v;
};
var refl = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var lowerLeibniz3of3 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz2of3 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz2of2 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz1of3 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz1of2 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var distinguished = function () {
    return Unsafe_Coerce.unsafeCoerce;
};
var distinguished1 = /* #__PURE__ */ distinguished();
var distinguishRight = {};
var distinguishLeft = {};
var refute = function () {
    return function (l) {
        return Data_Void.absurd(unDistinguished1(runLeibniz(l)(distinguished1(Data_Unit.unit))));
    };
};
var coerceSymm = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var coerce = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var categoryLeibniz = {
    identity: refl,
    Semigroupoid0: function () {
        return semigroupoidLeibniz;
    }
};
var identity = /* #__PURE__ */ Control_Category.identity(categoryLeibniz);
var applyLeibniz3of3 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz3of3 = /* #__PURE__ */ applyLeibniz3of3(identity);
var applyLeibniz2of3 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz2of3 = /* #__PURE__ */ applyLeibniz2of3(identity);
var applyLeibniz2of2 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz2of2 = /* #__PURE__ */ applyLeibniz2of2(identity);
var applyLeibniz1of3 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz1of3 = /* #__PURE__ */ applyLeibniz1of3(identity);
var applyLeibniz1of2 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz1of2 = /* #__PURE__ */ applyLeibniz1of2(identity);
var applyLeibniz = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz = /* #__PURE__ */ applyLeibniz(identity);
export {
    Leibniz,
    runLeibniz,
    coerce,
    coerceSymm,
    symm,
    liftLeibniz,
    liftLeibniz1of2,
    liftLeibniz2of2,
    liftLeibniz1of3,
    liftLeibniz2of3,
    liftLeibniz3of3,
    applyLeibniz,
    applyLeibniz1of2,
    applyLeibniz2of2,
    applyLeibniz1of3,
    applyLeibniz2of3,
    applyLeibniz3of3,
    lowerLeibniz,
    lowerLeibniz1of2,
    lowerLeibniz2of2,
    lowerLeibniz1of3,
    lowerLeibniz2of3,
    lowerLeibniz3of3,
    refute,
    semigroupoidLeibniz,
    categoryLeibniz,
    distinguishLeft,
    distinguishRight
};
